import React, { forwardRef, useId } from 'react';
import './FormField.css';

export interface FormTextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> {
  label: string;
  hint?: string;
  error?: string;
}

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ label, hint, error, required, className, ...rest }, ref) => {
    const id = useId();
    return (
      <div className={`form-field${error ? ' form-field--error' : ''}${className ? ` ${className}` : ''}`}>
        <label className="form-field__label" htmlFor={id}>
          {label}
          {required && <span className="form-field__required" aria-hidden="true"> *</span>}
        </label>
        <textarea
          ref={ref}
          id={id}
          className="form-field__textarea"
          required={required}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error ? `${id}-err` : hint ? `${id}-hint` : undefined}
          {...rest}
        />
        {hint && !error && <span id={`${id}-hint`} className="form-field__hint">{hint}</span>}
        {error && <span id={`${id}-err`} className="form-field__error" role="alert">{error}</span>}
      </div>
    );
  },
);
FormTextarea.displayName = 'FormTextarea';
